import React from 'react'
import Header from "./Header"

function PrivacyPolicy( data ) {
  return (
    <div className="informPageHoler">
      <Header headerContext='privacyPolicy'
      user={ data.user }
      logout={ data.logout }
      toggleGetChips={ data.toggleGetChips }
      width = { data.width }
      showSiteMenu = { data.showSiteMenu }
      toggleSiteMenu = { data.toggleSiteMenu }/>
      <div className='textContentHolder'>
        <h1>Privacy policy</h1>
        <dl className="list">
            <dt>Information We Collect:</dt>
            <li>We don't collect any personal information</li>
            <li>Cookies: We don't use cookies.</li>
        </dl>
        <dl className="list">
            <dt>Privacy Policy Updates:</dt>
            <li>This Privacy Policy is subject to change. Updates will be reflected on the Revision Date at the top of the policy. Continuing to use our site or services after any changes indicates your consent to the updated policy.</li>
        </dl>
      </div>
    </div>
  )
}

export default PrivacyPolicy;

<div class="privacy-policy">
    <h1>Privacy Policy</h1>
    <dl className="list">
        <h2>Information We Collect</h2>
        <dt>Personal Information:</dt>
        <p>We collect information that you provide directly or via third-party login services. This may include:</p>
        <ul>
            <li>Your first name</li>
            <li>Your last name</li>
            <li>Your profile picture or its URL</li>
            <li>Your user ID</li>
        </ul>
        <dt>Usage Data and Site Activity:</dt>
        <p>We automatically collect information related to your actions on the site. For example, this may include:</p>
        <ul>
            <li>Your clicks on site elements</li>
            <li>The duration of time you spend on the site</li>
        </ul>
        <dt>Cookies:</dt>
        <p>We do not use cookies to collect or store your data.</p>
    </dl>

    <dl className="list">
        <h2>How We Use Information and When We May Share It</h2>
        <p>Your personal information is used to enhance our user interface and improve the overall player experience.</p>
        <p>Profile details, such as your name, will be visible to other players in the rooms you join.</p>
        <p>We do not share your personal information with third-party services unless legally required.</p>
    </dl>

    <dl className="list">
        <h2>Compliance with Laws and Law Enforcement</h2>
        <p>We may disclose your personal information to government or law enforcement officials or private parties if required by law or if necessary to comply with legal obligations.</p>
    </dl>

    <dl className="list">
        <h2>Compliance and Security</h2>
        <p>We are committed to safeguarding your personal information using robust security measures. However, please note that no data transmission method can guarantee complete security.</p>
    </dl>

    <dl className="list">
        <h2>Children's Privacy</h2>
        <p>Our services are not directed to individuals under the age of 18, and we do not knowingly collect personal information from them.</p>
    </dl>

    <dl className="list">
        <h2>Privacy Policy Updates</h2>
        <p>This Privacy Policy is subject to change. Any updates will be reflected on the revision date at the top of this policy. Continued use of our site or services after changes indicates your acceptance of the updated policy.</p>
    </dl>
</div>



